module.exports = __webpack_public_path__ + "static/media/arrow.c4ff3b22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow.svg
// module id = 1384
// module chunks = 0